/* GENERATED by scripts/gen-help-meta.mjs — do not edit.
 *
 * Titles and dates for the operator manual, lifted out of the MDX so the
 * table of contents does not have to download fourteen article bodies to
 * render fourteen links. Edit the article, then run `pnpm help:meta`.
 * `pnpm help:meta:check` fails the gate if this drifts from the source.
 */
import type { HelpArticleMeta } from './articles.js';

export const HELP_ARTICLE_META: Record<string, Record<string, HelpArticleMeta>> = {
  en: {
    'agent-referrals': {
      title: 'Agent codes & referrals: that code at signup, explained',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'billing'],
    },
    billing: {
      title: 'Billing & your subscription',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'staff'],
    },
    branding: {
      title: 'Branding: your name on the door, not ours',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'catalog'],
    },
    broadcasts: {
      title: 'Marketing broadcasts: reach everyone who said yes',
      updatedAt: '2026-07-17',
      related: ['promotions', 'notifications'],
    },
    catalog: {
      title: 'The catalog: what you sell, priced per vehicle',
      updatedAt: '2026-07-17',
      related: ['branding', 'pos'],
    },
    faq: {
      title: 'Frequently asked questions',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'troubleshooting'],
    },
    'getting-started': {
      title: 'Getting started: from signup to your first ticket',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'pos', 'billing'],
    },
    loyalty: {
      title: 'Loyalty: points, tiers, and vouchers that come back',
      updatedAt: '2026-07-17',
      related: ['pos', 'promotions', 'getting-started'],
    },
    notifications: {
      title: 'Notifications: what your customers get, and when',
      updatedAt: '2026-07-17',
      related: ['broadcasts', 'queue-board'],
    },
    pos: {
      title: 'The POS: one tap from ready to paid',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'loyalty', 'catalog'],
    },
    promotions: {
      title: 'Promotions: discounts that apply themselves',
      updatedAt: '2026-07-17',
      related: ['loyalty', 'broadcasts', 'pos'],
    },
    'queue-board': {
      title: 'The queue board: run your line without the whiteboard',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'pos', 'staff'],
    },
    staff: {
      title: 'Staff & roles: the right buttons for the right hands',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'billing'],
    },
    troubleshooting: {
      title: 'Troubleshooting: when something doesn’t look right',
      updatedAt: '2026-07-17',
      related: ['faq', 'notifications', 'billing'],
    },
  },
  ms: {
    'agent-referrals': {
      title: 'Kod ejen & rujukan: kod semasa pendaftaran itu, dijelaskan',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'billing'],
    },
    billing: {
      title: 'Pengebilan & langganan anda',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'staff'],
    },
    branding: {
      title: 'Penjenamaan: nama anda di pintu, bukan nama kami',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'catalog'],
    },
    broadcasts: {
      title: 'Siaran pemasaran: capai semua yang berkata ya',
      updatedAt: '2026-07-17',
      related: ['promotions', 'notifications'],
    },
    catalog: {
      title: 'Katalog: apa yang anda jual, berharga ikut kenderaan',
      updatedAt: '2026-07-17',
      related: ['branding', 'pos'],
    },
    faq: {
      title: 'Soalan lazim',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'troubleshooting'],
    },
    'getting-started': {
      title: 'Mulakan: daripada pendaftaran ke tiket pertama anda',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'pos', 'billing'],
    },
    loyalty: {
      title: 'Kesetiaan: mata, tahap, dan baucar yang membawa pelanggan kembali',
      updatedAt: '2026-07-17',
      related: ['pos', 'promotions', 'getting-started'],
    },
    notifications: {
      title: 'Notifikasi: apa yang pelanggan anda terima, dan bila',
      updatedAt: '2026-07-17',
      related: ['broadcasts', 'queue-board'],
    },
    pos: {
      title: 'POS: satu tekanan dari sedia ke dibayar',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'loyalty', 'catalog'],
    },
    promotions: {
      title: 'Promosi: diskaun yang terpakai dengan sendirinya',
      updatedAt: '2026-07-17',
      related: ['loyalty', 'broadcasts', 'pos'],
    },
    'queue-board': {
      title: 'Papan giliran: urus barisan tanpa papan putih',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'pos', 'staff'],
    },
    staff: {
      title: 'Kakitangan & peranan: butang yang betul di tangan yang betul',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'billing'],
    },
    troubleshooting: {
      title: 'Penyelesaian masalah: bila ada yang tak kena',
      updatedAt: '2026-07-17',
      related: ['faq', 'notifications', 'billing'],
    },
  },
  zh: {
    'agent-referrals': {
      title: '代理代码与推荐：注册时那个代码，说清楚',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'billing'],
    },
    billing: {
      title: '账单与订阅',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'staff'],
    },
    branding: {
      title: '品牌设置:门口挂您的名字,不是我们的',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'catalog'],
    },
    broadcasts: {
      title: '营销群发：触达每一位说过“可以”的顾客',
      updatedAt: '2026-07-17',
      related: ['promotions', 'notifications'],
    },
    catalog: {
      title: '服务目录:您卖什么,按车型定价',
      updatedAt: '2026-07-17',
      related: ['branding', 'pos'],
    },
    faq: {
      title: '常见问题',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'troubleshooting'],
    },
    'getting-started': {
      title: '快速上手:从注册到第一张洗车单',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'pos', 'billing'],
    },
    loyalty: {
      title: '会员忠诚:积分、等级,和让人回头的代金券',
      updatedAt: '2026-07-17',
      related: ['pos', 'promotions', 'getting-started'],
    },
    notifications: {
      title: '通知：您的顾客何时会收到什么',
      updatedAt: '2026-07-17',
      related: ['broadcasts', 'queue-board'],
    },
    pos: {
      title: '收银(POS):从待取车到已付款,一次点击',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'loyalty', 'catalog'],
    },
    promotions: {
      title: '促销：自动生效的折扣',
      updatedAt: '2026-07-17',
      related: ['loyalty', 'broadcasts', 'pos'],
    },
    'queue-board': {
      title: '排队看板:告别白板,管好队伍',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'pos', 'staff'],
    },
    staff: {
      title: '员工与角色:对的按钮,交给对的手',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'billing'],
    },
    troubleshooting: {
      title: '故障排查：感觉不对劲的时候',
      updatedAt: '2026-07-17',
      related: ['faq', 'notifications', 'billing'],
    },
  },
  ta: {
    'agent-referrals': {
      title: 'முகவர் குறியீடுகளும் பரிந்துரைகளும்: பதிவின்போது வந்த அந்தக் குறியீடு',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'billing'],
    },
    billing: {
      title: 'பில்லிங் & உங்கள் சந்தா',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'staff'],
    },
    branding: {
      title: 'பிராண்டிங்: வாசலில் உங்கள் பெயர், எங்களுடையது அல்ல',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'catalog'],
    },
    broadcasts: {
      title: 'மார்க்கெட்டிங் அறிவிப்புகள்: சம்மதித்த அனைவரையும் சென்றடையுங்கள்',
      updatedAt: '2026-07-17',
      related: ['promotions', 'notifications'],
    },
    catalog: {
      title: 'சேவைப் பட்டியல்: நீங்கள் விற்பது, வாகன வகைக்கு ஏற்ற விலையில்',
      updatedAt: '2026-07-17',
      related: ['branding', 'pos'],
    },
    faq: {
      title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'troubleshooting'],
    },
    'getting-started': {
      title: 'தொடங்குங்கள்: பதிவு முதல் உங்கள் முதல் டிக்கெட் வரை',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'pos', 'billing'],
    },
    loyalty: {
      title: 'விசுவாசம்: புள்ளிகள், நிலைகள், திரும்ப அழைக்கும் வவுச்சர்கள்',
      updatedAt: '2026-07-17',
      related: ['pos', 'promotions', 'getting-started'],
    },
    notifications: {
      title: 'அறிவிப்புகள்: உங்கள் வாடிக்கையாளர்களுக்கு எப்போது என்ன கிடைக்கும்',
      updatedAt: '2026-07-17',
      related: ['broadcasts', 'queue-board'],
    },
    pos: {
      title: 'POS: தயார் நிலையிலிருந்து பணம் பெறுவது வரை ஒரே தட்டு',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'loyalty', 'catalog'],
    },
    promotions: {
      title: 'விளம்பரச் சலுகைகள்: தானாகவே பொருந்தும் தள்ளுபடிகள்',
      updatedAt: '2026-07-17',
      related: ['loyalty', 'broadcasts', 'pos'],
    },
    'queue-board': {
      title: 'வரிசைப் பலகை: வெள்ளைப் பலகை இல்லாமல் வரிசையை நடத்துங்கள்',
      updatedAt: '2026-07-17',
      related: ['getting-started', 'pos', 'staff'],
    },
    staff: {
      title: 'ஊழியர்களும் பொறுப்புகளும்: சரியான பொத்தான்கள், சரியான கைகளில்',
      updatedAt: '2026-07-17',
      related: ['queue-board', 'billing'],
    },
    troubleshooting: {
      title: 'சிக்கல் தீர்வு: ஏதோ சரியில்லை எனத் தோன்றும்போது',
      updatedAt: '2026-07-17',
      related: ['faq', 'notifications', 'billing'],
    },
  },
};
